/* eslint-disable max-len */
import React, { useState ,useRef, useEffect} from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';

const PhoneNumberValidator = ({
    label,
    placeholder,
    id,
    htmlFor,
    value,
    emptyField,
    handleOnChangeInput,
    isCode,
    countryCodeList,
    index,
    disabled,
    country_code,
    countryCodeVal,
    setCountryCodeVal,
    submitSelected,
    handleCOuntryCodeForObj,
    isPhoneNumberValid,
    setIsPhoneNumberValid,
    data_testid,
    isOnType,
    setIsOnType,
    maxLength,
    isPatient
}) => {

    const [phoneNumber, setPhoneNumber] = useState(value || '');
    const [isValid, setIsValid] = useState(true);
    const [isEntered, setIsEntered] = useState(false);
    const [isOpen, setisOpen] = useState(false)
    const ref = useRef();
    const prevValueRef = useRef(value || '');
    const isRestoringRef = useRef(false);
    useOnClickOutside(ref, () => {
        setisOpen(false);
    });

    // Re-validate phone number when value is restored externally (e.g., after validation prevents deletion)
    // This handles the case where user tries to clear the field but validation prevents it
    useEffect(() => {
        const numericValue = value ? value.replace(/\D/g, '') : '';
        const numericPhoneNumber = phoneNumber ? phoneNumber.replace(/\D/g, '') : '';
        
        // Re-validate if value prop has content but phoneNumber state is empty or different
        // This handles the restoration scenario after validation prevents deletion
        if (value && value.trim() !== '' && numericValue !== '' && 
            numericValue !== numericPhoneNumber && !isRestoringRef.current) {
            
            // Mark that we're restoring to prevent infinite loop
            isRestoringRef.current = true;
            
            // Sync phoneNumber state with value prop immediately
            setPhoneNumber(numericValue);
            
            // Validate immediately (no setTimeout delay)
            try {
                const numericCountryCode = ((countryCodeVal === ""|| countryCodeVal===undefined) ? country_code : countryCodeVal).replace(/\D/g, '');
                const fullPhoneNumber = `+${numericCountryCode}${numericValue}`;
                
                if (fullPhoneNumber.trim() && numericValue !== '') {
                    const phoneNumberObj = parsePhoneNumber(fullPhoneNumber, numericCountryCode);
                    const isValidPhone = phoneNumberObj ? phoneNumberObj.isValid() : false;
                    
                    if(index===undefined){
                        if(id==="mobile_number"){
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                mobile_number:isValidPhone
                            }))
                        }
                        else if(id==="billing_mobile_number"){
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                billing_mobile_number:isValidPhone
                            }))
                        }
                        else if(id==="fax"){
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                fax:isValidPhone
                            }))
                        }
                        else{
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                main_number:isValidPhone
                            }))
                        }
                    }else{
                        setIsPhoneNumberValid(index,numericValue?.length>15?false:isValidPhone,id)
                    }
                    
                    setIsValid(isValidPhone);
                }
            } catch (error) {
                setIsValid(false);
                // Also set isPhoneNumberValid to false on error
                if(index===undefined){
                    if(id==="mobile_number"){
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            mobile_number:false
                        }))
                    }
                    else if(id==="billing_mobile_number"){
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            billing_mobile_number:false
                        }))
                    }
                    else if(id==="fax"){
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            fax:false
                        }))
                    }
                    else{
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            main_number:false
                        }))
                    }
                }else{
                    setIsPhoneNumberValid(index,false,id)
                }
            }
            
            // Reset the flag after state updates complete
            // Use requestAnimationFrame to ensure it runs after React's state update cycle
            requestAnimationFrame(() => {
                setTimeout(() => {
                    isRestoringRef.current = false;
                }, 0);
            });
        }
        
        // Update ref to track previous value prop
        prevValueRef.current = value || '';
    }, [value, phoneNumber, countryCodeVal, country_code, id, index, setIsPhoneNumberValid]);



    const handlePhoneNumberChange = (event,isbtnclick,countryCode) => {

        setIsEntered(true)
        const newValue = isbtnclick!==undefined?event:event.target.value;

        // Remove non-numeric characters from the input
        const numericValue = newValue.replace(/\D/g, '');

        setPhoneNumber(numericValue);
        index===undefined?handleOnChangeInput(id, numericValue):handleOnChangeInput(id,numericValue,index)

        try {
            // Extract numeric part from the country code
            const numericCountryCode = countryCode===undefined?((countryCodeVal === ""|| countryCodeVal===undefined) ? country_code : countryCodeVal).replace(/\D/g, '') :countryCode;
            const fullPhoneNumber = `+${numericCountryCode}${numericValue}`;

            // Check if the fullPhoneNumber is empty and handle accordingly
            // BUT: Don't set isPhoneNumberValid to false if value prop still has content
            // This handles the case where parent validation prevents deletion
            if (!fullPhoneNumber.trim() || numericValue === '') {
                // Only set validation to false if value prop is also empty
                // If value prop has content, the useEffect will handle re-validation
                if (!value || value.trim() === '') {
                    setIsValid(emptyField);
                    // Also update isPhoneNumberValid when field is empty AND value prop is empty
                    if(index===undefined){
                        if(id==="mobile_number"){
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                mobile_number:emptyField
                            }))
                        }
                        else if(id==="billing_mobile_number"){
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                billing_mobile_number:emptyField
                            }))
                        }
                        else if(id==="fax"){
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                fax:emptyField
                            }))
                        }
                        else{
                            setIsPhoneNumberValid((prev)=>({
                                ...prev,
                                main_number:emptyField
                            }))
                        }
                    }else{
                        setIsPhoneNumberValid(index,emptyField,id)
                    }
                }
                // If value prop has content but numericValue is empty, don't set validation state
                // Let the useEffect handle it
            } else {

                // Pass numericCountryCode to parsePhoneNumber
                const phoneNumberObj = parsePhoneNumber(fullPhoneNumber, numericCountryCode);
                if(index===undefined){
                    if(id==="mobile_number"){
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            mobile_number:phoneNumberObj?.isValid()
    
                        }))
                    }
                    else if(id==="billing_mobile_number"){
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            billing_mobile_number:phoneNumberObj?.isValid()
    
                        }))
                    }
                    else if(id==="fax"){
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            fax:phoneNumberObj?.isValid()
    
                        }))
                    }
                    else{
                        setIsPhoneNumberValid((prev)=>({
                            ...prev,
                            main_number:phoneNumberObj?.isValid()
    
                        }))
                    }
                    
                }else{
                    setIsPhoneNumberValid(index,newValue?.length>15?false:phoneNumberObj?.isValid(),id)
                    
                }
                
                // Check if phoneNumberObj is defined before accessing its properties
                setIsValid(phoneNumberObj ? phoneNumberObj.isValid() : false);

            }
        } catch (error) {
            setIsValid(false);
        }
    };

    function handleCountryCOde(item){
        setIsOnType!==undefined&&setIsOnType(false)
        handlePhoneNumberChange(value,'btnclick',item.split("-")[0].trim())
        if(index!==undefined){
            handleCOuntryCodeForObj(index,item,id)
            setisOpen(false)

        }else{
            setCountryCodeVal(item.split("-")[0].trim())
            setisOpen(false)
        }
         
    }

    return (
        <div>
            <label htmlFor={htmlFor} className='text-xs font-semibold text-[#000] mb-1.5 more-lines'>{label}</label>
            <div className='relative'>
                <div className={`absolute top-[50%] -translate-y-[50%] left-1 ${isOpen? "z-[999]" : "z-[0]"}`}>
                    {/* {isCode && (
                        <select value={(countryCodeVal === ""||countryCodeVal===undefined) ? country_code : countryCodeVal} onChange={handleCountryCodeChange}>
                            {countryCodeList.map((code, index) => {
                                // Extract numeric part from the country code
                                const numericCountryCode = code.replace(/\D/g, '');

                                return (
                                    <option key={index} value={numericCountryCode}>
                                        +{numericCountryCode}
                                    </option>
                                );
                            })}
                        </select>
                    )} */}
                    {isCode && <div className='relative'>
                        <button onClick={() => setisOpen(!isOpen)} className='absolute top-[50%] -translate-y-[50%] left-4 text-base font-normal text-[#000000] flex items-center justify-between w-[64px] z-0'>
                            <p className='pr-0.5'>+{(countryCodeVal === ""|| countryCodeVal===undefined) ? country_code : countryCodeVal}</p>
                            <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                        </button>
                        <ul  ref={ref} className={`absolute top-[26px] z-50 left-0 p-2 rounded-lg border border-[#C5C9DA] w-[104px] bg-white h-fit ${isOpen ? "" : "hidden"}`}>
                            <li>
                                <ul className='max-h-[150px] overflow-auto pr-1 scrollbar_gray_thin bg-white'>

                                    {countryCodeList?.map((item, index) => (
                                        <li key={index}>
                                            <p  onClick={()=>{handleCountryCOde(item)}}className={`text-sm font-normal cursor-pointer  ${item===countryCodeVal?`text-base text-[#008586]`:'text-sm font-normal text-[#000]'} hover:text-[#008586] mb-2`}>{item}</p>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        </ul>
                    </div>
                    }
                </div>
                <input
                    type='text'
                    id={id}
                    maxLength={maxLength!==undefined?maxLength:null}
                    data-testid={data_testid}
                    value={value}
                    disabled={disabled}
                    autoComplete='off'
                    onChange={(e)=>{setIsOnType!==undefined&&setIsOnType(true),handlePhoneNumberChange(e)}}
                    placeholder={placeholder}
                    className={`border ${emptyField || (submitSelected&&(!isValid||(isPatient!==undefined&&!isPhoneNumberValid))&&value!="") ? 'border-[#C81720]' : 'border-[#C5C9DA] '} rounded-lg pr-3.5 pl-[90px] py-[11px] text-base font-normal text-[#000B17] w-full disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-sm outline-none appearance-none`}
                />
            </div>
            { value?.length>0 && <>
                {isPhoneNumberValid?(
                    <p style={{ color: 'green' }} className='text-sm font-normal mt-2'>Valid {label.endsWith('*')?label.slice(0, -1):label}</p>
                ):(
                    <p className='text-sm font-normal text-[#F04438] mt-2'>Invalid {label.endsWith('*')?label.slice(0, -1):label}</p>
                )
                }
            
            </>
            }

        </div>
    );
};

export default PhoneNumberValidator;
